angular.module('gym.components').directive('sequenceStepAdvancedOptions', function() {
  return {
    restrict: 'EA',
    template: require('templates/components/sequences/sequence_step_advanced_options.html.slim'),
    scope: {
      sequence: '=',
      sequenceStep: '=',
      reports: '='
    },
    controller: ["$rootScope", "$scope", "SequenceService", function($rootScope, $scope, SequenceService) {
      var gym;
      gym = $rootScope.gym;
      $scope.toggle = function() {
        return $scope.expanded = !$scope.expanded;
      };
      $scope.skipConditionsVisible = function() {
        if (SequenceService.isForseeable($scope.sequence)) {
          return $scope.sequenceStep.position > 1;
        } else {
          return $scope.sequenceStep.position > 2;
        }
      };
      $scope.hasSkipConditions = function() {
        return _.find($scope.sequenceStep.sequence_conditions_attributes, function(condition) {
          var ref;
          return !condition._destroy && ((ref = condition.type) === 'ReportSkipSequenceCondition' || ref === 'LinkedReportSkipSequenceCondition' || ref === 'ScopedReportSkipSequenceCondition');
        });
      };
      $scope.isReportConditionExists = function(step) {
        return SequenceService.isReportConditionExists(step);
      };
      $scope.isScopedReportConditionExists = function(step) {
        return SequenceService.isScopedReportConditionExists(step);
      };
      $scope.isEnrolmentLimitSequenceConditionExists = function(step) {
        return SequenceService.isEnrolmentLimitSequenceConditionExists(step);
      };
      $scope.hasReportSkipSequenceCondition = function(step) {
        return SequenceService.hasReportSkipSequenceCondition(step);
      };
      $scope.removeCondition = function(step, index) {
        if (step.sequence_conditions_attributes[index].id) {
          return step.sequence_conditions_attributes[index]._destroy = 1;
        } else {
          return step.sequence_conditions_attributes.splice(index, 1);
        }
      };
      $scope.addRunCondition = function(step) {
        return step.isRunConditionCreating = true;
      };
      return $scope.addSkipCondition = function(step) {
        return step.isSkipConditionCreating = true;
      };
    }]
  };
});
